import PresetService from '../src/dashboard/PresetService';
import Store from '../src/data/Store.js';
import Preset from '../src/dashboard/Preset.js';
import Utility from '../src/core/Utility.js';

class DashboardController {
	constructor($q, $element, $scope, $location, serviceMessageBus, serviceTranslate) {
		this.$q = $q;
		this.msgbus = serviceMessageBus.get();
		this.serviceTranslate = serviceTranslate;
		// this.serviceNotification = serviceNotification
		//this.client = new Araqne.QueryService(window.currentSession);
		this.el = $element;
		// this.currentPreset;
		this.scope = $scope;
		this.presets = {};
		this.isReadOnly = true;
		this.currentTab;

		// this.scope.$on('DashboardController:setPreset', this.checkPresetMigration.bind(this));
		this.scope.$on('DashboardController:onParentPresetChanged', this.onParentPresetChanged.bind(this));
		this.scope.$on('DashboardController:setPreset', this.makeParentPreset.bind(this));
		this.scope.$on('DashboardController:setTheme', (e, theme, notSave) => {	
			PresetService.getPreset(this.msgbus , this.currentParentPreset.guid).onSuccess(function(resp){
				this.currentParentPreset = resp.preset;
				if(!!this.currentParentPreset.state.style) {
					this.currentParentPreset.state.style.theme = theme;
				}
				else {
					this.currentParentPreset.state.style = {'theme': theme};
				}
				this.currentParentPreset.state.widgets[0].data.tabs = this.dataInners;
				this.setTheme(null, theme);
				if(!this.isReadOnly && !notSave){
					PresetService.setPreset(this.msgbus, this.currentParentPreset);
				}
			}.bind(this));
		});
		this.scope.$on('DashboardController:updateDataSource', this.updateDataSource.bind(this));
		this.scope.$on('DashboardController:destroy', this.destroy.bind(this));
		this.scope.$on('DashboardController:afterPresetChanged', (e, config) => {
			PresetService.getPreset(this.msgbus , this.currentParentPreset.guid).onSuccess(function(resp){
				this.currentParentPreset = resp.preset;
				this.currentParentPreset.state.widgets[0].data.tabs = this.dataInners;
				// if(!this.isReadOnly){
				// 	this.setParentStyle(config);
				// 	PresetService.setPreset(this.msgbus, this.currentParentPreset);
				// 	this.presets[this.currentTab.contents].resizeWidgets();
				// }
			}.bind(this));
		});
		this.scope.$on('PresetConfigController:onPresetConfigChanged', (e, config) => {
			this.setWidgetTitleSize(config.widgetTitleFontSize);
				// PresetService.getPreset(this.msgbus , this.currentParentPreset.guid).onSuccess(function(resp){
				// 	this.currentParentPreset = resp.preset;
				// 	this.currentParentPreset.state.widgets[0].data.tabs = this.dataInners;
				// 	if(!this.isReadOnly){
				// 		this.setParentStyle(config);
				// 		PresetService.setPreset(this.msgbus, this.currentParentPreset);
				// 		this.presets[this.currentTab.contents].resizeWidgets();
				// 	}
				// }.bind(this));
		});

		$(window).on('resize.dashboard', Utility.debounce(() => {
			this.presets[this.currentTab.contents].resizeWidgets();
		}, 200));

		this.scope.$on('DashboardController:resetWidgets', (evt, data) => {
			let currentPreset = this.presets[this.currentTab.contents];
			currentPreset.resetWidget(currentPreset.meta.widgets);
		});
		
		this.scope.$on('DashboardController:refreshAll', (e, args) => {
			this.activePreset(this.currentTab, args.refresh);
		}); 

		// PresetListV4를 통해 importPreset이 불리면 presets를 초기화
		this.scope.$on('DashboardController:onRefreshPreset', (e) => {
			var keys = Object.keys(this.presets);
			for (var key of keys) {
				this.presets[key].suspend();
				delete this.presets[key];
			}

			this.presets = {};
		})
	}

	onParentPresetChanged(event, updatedParentPreset){
		if(!updatedParentPreset){
			return;
		}
		this.currentParentPreset = updatedParentPreset;
	}

	setWidgetTitleSize(widgetTitleFontSize) {
		var styleText = `#view-dashboard .widget-title {
				height: ${14 + widgetTitleFontSize}px;
				line-height: ${widgetTitleFontSize + 13}px;
			}
			#view-dashboard .widget-title > a,
			#view-dashboard .widget-title > span.title {
				font-size: ${widgetTitleFontSize}px;
			}
			.widget-container {
				top: ${28 + widgetTitleFontSize * 0.9}px;
			}`;

		if($('#elPresetStyle').length === 0) {
			$(`<style id="elPresetStyle">${styleText}</style>`).prependTo('body');
		}
		else {
			// change from 'innerText' to 'html for IE11(#2729)
			$('#elPresetStyle').html(styleText);
		}
	}

	updateDataSource(e, list) {
		PresetService.getPreset(this.msgbus , this.currentParentPreset.guid).onSuccess(function(resp){
			this.currentParentPreset = resp.preset;
			this.currentParentPreset.state.widgets[0].data.tabs = this.dataInners;
			if(!this.isReadOnly){
				this.currentParentPreset.state.datasource = list.filter(ctx => {
					return !ctx.instant;
				});
				this.currentParentPreset.state.version = '2.0.1';
				console.log(this.currentParentPreset);
				console.warn('------- parent saved!! -------');
				PresetService.setPreset(this.msgbus, this.currentParentPreset).onSuccess(function(resp){
					this.scope.$emit('DashboardController:updateParentPreset', this.currentParentPreset);
				}.bind(this));
			}
		}.bind(this));
	}

	openDeleteTabModal(inner, idx) {
		this.el.find('.mdlRemovePresetTab')[0].showDialog();

		this.deleteTab = () => {
			PresetService.removePreset(this.msgbus, inner.contents)
			.onSuccess(() => {
				PresetService.getPreset(this.msgbus , this.currentParentPreset.guid)
				.onSuccess(function(resp){
					this.currentParentPreset = resp.preset;
					this.currentParentPreset.state.widgets[0].data.tabs = this.dataInners;
					if(this.currentParentPreset.state.widgets[0].data.homeIndex == idx){
						this.currentParentPreset.state.widgets[0].data.homeIndex = 0;
					}  else if(this.currentParentPreset.state.widgets[0].data.homeIndex > idx){
						this.currentParentPreset.state.widgets[0].data.homeIndex--;
					}
					if(!!this.dataInners[idx].is_active){
						this.loadNearestPreset(idx - 1);
					}
					this.dataInners[idx] = null;
					this.dataInners.splice(idx, 1);
					if(!this.isReadOnly){
						PresetService.setPreset(this.msgbus, this.currentParentPreset).onSuccess(resp =>{
							this.scope.$emit('DashboardController:updateParentPreset', this.currentParentPreset);
						});
					}
					this.el.find('.mdlRemovePresetTab')[0].hideDialog();
					delete this.presets[inner.contents]; // addChild에서 사용하는 guid가 여기 contetns에 들어가 있다. 
					this.scope.$apply();
				}.bind(this));
			});
		}
	}

	loadNearestPreset(idx) {
		if(idx < 0) {
			// first tab(idx=0) removed
			idx = 1;
		}
		// if(idx < 0) {
		// 	throw new TypeError('loadNearestPreset error');
		// 	return;
		// }

		this.activePreset(this.dataInners[idx]);
	}

	addTab() {
		var msgPleaseInsertName = this.serviceTranslate('$S_msg_PleaseInputTabName');
		var newTabName = prompt(msgPleaseInsertName, 'Tab ' + (this.dataInners.length + 1));
		if(newTabName == null) return;

		var childguid = 'p' + Utility.generateType2();
		var tabctx = {
			'name': newTabName,
			'guid': 't' + Utility.generateType2(),
			'type': 'dockpanel',
			"contents": childguid
		}

		this.dataInners.push(tabctx);

		var innerCtx = PresetService.createChild(childguid, this.currentParentPreset.guid, newTabName);
		PresetService.getPreset(this.msgbus , this.currentParentPreset.guid).onSuccess(function(resp){
			this.currentParentPreset = resp.preset;
			this.currentParentPreset.state.widgets[0].data.tabs = this.dataInners;
			if(!this.isReadOnly){
				PresetService.setPreset(this.msgbus, innerCtx);
				PresetService.setPreset(this.msgbus, this.currentParentPreset).onSuccess(resp => {
					this.scope.$emit('DashboardController:updateParentPreset', this.currentParentPreset);
				});
			}
		}.bind(this));	

		this.addChildPreset(innerCtx);
	}

	makeParentPreset(e, preset, options) {

		this.options = options;
		this.currentParentPreset = preset;
		var widget = preset.state.widgets[0];
		this.homeIndex = widget.data.homeIndex || 0; // home's index of tabs , null(undefined) or number
		this.dataInners = widget.data.tabs;

		// var active = widget.data.tabs.find(tab => {
		// 	return tab.is_active;
		// });
		var active = widget.data.tabs[this.homeIndex];
		if(!active && (widget.data.tabs.length <= this.homeIndex)){
			this.homeIndex = 0;
			widget.data.homeIndex = 0;
			active = widget.data.tabs[this.homeIndex];
			PresetService.setPreset(this.msgbus, this.currentParentPreset).onSuccess(resp =>{
				this.scope.$emit('DashboardController:updateParentPreset', this.currentParentPreset);
			});
		}
		active.is_active = true;

		widget.data.tabs.forEach(tab => {
			if(active.guid !== tab.guid) {
				tab.is_active = false;
			}

			this.getInnerPreset(tab, options);
		});
/*
		this.currentParentPreset.state.datasource = [
			{
				guid: 'sample-data-source',
				name: 'sample-data-source',
				query: 'logdb count',
				interval: 5
			}
		]
		*/;
		//this.store = new Store(this.currentParentPreset.state.datasource || [], this.client);
		this.store = new Store(this.currentParentPreset.state.datasource || []);
		this.store.onFilterChange(() => {
			console.log('onFilterChange store');
			this.scope.$emit('DashboardController:onFilterChange');
		});
		if(!!preset.state.style){
			this.setWidgetTitleSize(preset.state.style.widgetTitleFontSize || 14);
		}
	}

	/**
	 * 프리셋의 migration 여부를 체크
	 * @param {[object]} e       broadcast event
	 * @param {[object]} preset  부모 프리셋
	 * @param {[object]} options 옵션
	 */
	checkPresetMigration(e, preset, options) {
		const oldPresetVersion = '1.5.1';

		if(!preset) return;
		// console.log('parent preset', preset);
		let parentPreset = preset;

		// 부모 프리셋에는 tab 정보밖에 없음.
		if(parentPreset.state.version === oldPresetVersion) {
			// 모든 자식의 프리셋 구함
			let getPresetPromises = [];
			parentPreset.state.widgets.forEach(widget => {
				widget.data.tabs.forEach(tabData => {
					getPresetPromises.push(this.getChildPreset(tabData.contents));
				});
			});

			this.$q.all(getPresetPromises)
			.then(allChildPresets => {
				// console.log('allChildPresets', allChildPresets);

				// 자식 프리셋의 widget을 하나의 배열로 합쳐서 migration 을 진행한다.(모든 자식 프리셋에서 중복을 없애기 위함)
				// migrated은 datasource, widgets, version을 가지고 있음.
				let migrated = PresetService.migrateFrom151(this.combineChildWidgets(allChildPresets));
				// console.log('migrated', migrated);

				// 자식 프리셋들의 정보를 변경 해준뒤 setPreset을 한다.
				let setPresetPromises = [];
				allChildPresets.forEach(childPreset => {
					childPreset.state.version = migrated.version;

					if(childPreset.state.widgets.length) {
						childPreset.state.widgets.forEach(childWidget => {
							migrated.widgets.forEach(migratedWidget => {
								if(childWidget.guid === migratedWidget.guid) {
									childWidget = migratedWidget;
								}
							});
						});
					}

					// console.log('new childPreset', childPreset);
					setPresetPromises.push(this.setPreset(childPreset));
				});

				// 자식 프리셋을 모두 set한 뒤에, 부모 프리셋에 datasource를 넣고 setPreset을 다시 한다.
				this.$q.all(setPresetPromises)
				.then(() => {
					parentPreset.state.version = migrated.version;
					parentPreset.state.datasource = migrated.datasource;

					this.setPreset(parentPreset)
					.then(() => {
						console.log('last parentPreset', parentPreset);
						this.makeParentPreset(e, parentPreset, options);
					})
					.catch((err) => {
						throw new TypeError(err.toString());
					});
				})
				.catch((err) => {
					throw new TypeError(err.toString());
				});
			})
			.catch( () => {
				console.error('get all child preset failed');
			});
		}else{
			console.log('make preset');
			this.makeParentPreset(e, parentPreset, options);
		}
	}

	/**
	 * childPresetId로 자식 프리셋 정보 가져옴
	 * @param {[integer]} childPresetId [부모 프리셋의 tab.contents]
	 */
	getChildPreset(childPresetId) {
		let deferred = this.$q.defer();
		PresetService.getPreset(this.msgbus, childPresetId)
		.onSuccess( resp => {
			deferred.resolve(resp.preset);
		})
		.onFailure( err => {
			throw new TypeError(err.toString());
		});

		return deferred.promise;
	}

	/**
	 * 자식 프리셋에서 모든 widgets를 모은다
	 * @param  {[array]} childPresets [자식 프리셋 배열]
	 * @return {[array]}              [자식 프리셋의 state.widgets를 하나로 합친 배열]
	 */
	 combineChildWidgets(childPresets) {
		let widgetsArray = [];
		if(Array.isArray(childPresets) && childPresets.length) {
			childPresets.forEach(childPreset => {
				let childWidgets = childPreset.state.widgets;
				if(childWidgets.length) {
					widgetsArray = widgetsArray.concat(childWidgets);
				}
			});
		}

		console.log('widgetsArray', widgetsArray);
		return widgetsArray;
	}

	/**
	 * 프리셋을 설정한다.
	 * @param {[object]} preset 설정할 프리셋
	 */
	setPreset(preset) {
		let deferred = this.$q.defer();
		if(!this.isReadOnly){
			PresetService.setPreset(this.msgbus, preset)
			.onSuccess( () => {
				deferred.resolve();
			})
			.onFailure( (err) => {
				deferred.reject(err);
			});
		}
		return deferred.promise;
	}

	getInnerPreset(metaTab, options) {
		options = Object.assign({
			isReadOnly: true
		}, options);
		this.isReadOnly = options.isReadOnly;

		// 공유 대시보드에서는 modal이 필요없으므로, 가린다.
		if(!!this.isReadOnly) {
			this.el.find('.mdlRemovePresetTab').hide();
		} else {
			this.el.find('.mdlRemovePresetTab').show();
		}		

		PresetService.getPreset(this.msgbus, metaTab.contents)
		.onSuccess(resp => {
			if(!this.presets[metaTab.contents]) {
				this.addChildPreset(resp.preset);
			}

			if(metaTab.is_active) {
				this.activePreset(metaTab, options);
			}
		})
		.onFailure(err => {
			throw new TypeError(err.toString());
		});
	}

	addChildPreset(meta) {
		this.presets[meta.guid] = new Preset(meta, this.store, this.msgbus, this.isReadOnly, {
			onInfoClick: (widget) => {
				this.scope.$emit('DashboardController:onInfoClick', widget);
			},
			onFailClick: (widget) => {
				this.scope.$emit('DashboardController:onFailClick', widget);
			},
			onDrillDownChanged: (action) => {
				// this.applyDrillDown(action);
				this.scope.$emit('DashboardController:onDrillDownChanged');
			}, // 이부분 미구현, dashboardContainerController에 이벤트 받는곳은 있지만 실제로 Preset.js에서 assign하거나 사용하는 부분 없음.
			getCurrentTab: () => {
				return this.currentTab;;
			},
			el: this.el
		}, this.$q);
		//set 기능 추가 떄문에 callback 추
		// this.presets[meta.guid].onSetParameterChanged(this.handleSetChanged.bind(this));
		// this.presets[meta.guid].onSetParameterReset(this.handleSetParameterReset.bind(this));
	}

	// handleSetParameterReset(parentGuid){
	// 	this.handleSetChanged(null, parentGuid);
	// 	// for( var tabGuid in this.presets) {
	// 	// 	this.presets[tabGuid].widgets.forEach(widget => {
	// 	// 		widget.model.setPrependParams(null);
	// 	// 		widget.resume();
	// 	// 	})
	// 	// }		
	// }

	// handleSetChanged (map , parentGuid, valType){
	// 	//for( var tabGuid in this.presets) {
	// 		this.presets[parentGuid].widgets.forEach(widget => {
	// 			widget.model.setPrependParams(map, valType);
	// 			//widget.resume(); // 이 함수로 재시작하면 layout부터 다시 시작하므로, abstractWidget의 _resume함수(query setting등을 담당)를 직접 호출.
	// 			widget._resume();
	// 		})
	// 	//}
	// }

	onPresetChanged(oldMetaTab, newMetaTab) {
		if(!!oldMetaTab) {
			oldMetaTab.is_active = false;
		}
		newMetaTab.is_active = true;

		this.currentTab = newMetaTab;

		// 공유 대시보드에서 
		// if(!!this.isReadOnly) {
		// 	// 원래 대시보드의 테마와 위젯 제목 크기를 적용시킵니다.
		// 	var theme = 'white',
		// 	widgetTitleFontSize = '14';
		// 	if(!!this.currentParentPreset.state) {
		// 		theme = this.currentParentPreset.state.style.theme;
		// 		widgetTitleFontSize = this.currentParentPreset.state.style.widgetTitleFontSize;
		// 	}

		// 	this.setTheme(null, theme);
		// 	this.setWidgetTitleSize(widgetTitleFontSize);
		// }
	}

	activePreset(metaTab, refresh) {
		// if(!!this.currentTab && this.currentTab.guid === metaTab.guid) {
		// 	return;
		// } 
		// guid는 클론시에 그대로 복사하기 떄문에 guid로 비교하면 안됨. contents는 unique하기때문에 이것으로 비교를 해야한다.

		if(!refresh) {
				if(!!this.currentTab && this.currentTab.contents === metaTab.contents) {
				return;
			}
		}

		var currentEl = this.el;

		// 현재 탭의 content를 dockpanel에 넣어줍니다.
		$(currentEl).find('.dockpanel.tab-content').attr('tab-id', metaTab.contents);

		var guid = metaTab.contents;
		for(var key in this.presets) {
			if(key === guid) {
				this.presets[key].render(this.el.find('div.dockpanel'));
				this.presets[key].resume();
			}
			else {
				this.presets[key].suspend();
			}
		}

		this.onPresetChanged(this.currentTab, metaTab);
		this.scope.$emit('DashboardController:onPresetChanged', this.presets[guid]);
	}

	setTheme(e, theme) {
		PresetService.setPresetInfo({'theme': theme === 'black' ? 'black': 'white'});
		var elDock = this.el;
		elDock.removeClass((index, css) => {
			return (css.match (/(^|\s)dock-theme-\S+/g) || []).join(' ');
		});
		elDock.addClass(`dock-theme-${theme}`);

		this.presets[this.currentTab.contents].setTheme(theme);
	}

	onTitleChange(newval, oldval) {
		if(!this.isReadOnly){
			this.currentTab.name = newval;
			PresetService.getPreset(this.msgbus , this.currentParentPreset.guid).onSuccess(function(resp){
				this.currentParentPreset = resp.preset;
				this.currentParentPreset.state.widgets[0].data.tabs = this.dataInners;
				PresetService.setPreset(this.msgbus, this.currentParentPreset).onSuccess(resp =>{
					this.scope.$emit('DashboardController:updateParentPreset', this.currentParentPreset);
				});
			}.bind(this));
		}
	}

	setHome(inner, index) {
		PresetService.getPreset(this.msgbus , this.currentParentPreset.guid).onSuccess(function(resp){
			this.currentParentPreset = resp.preset;
			this.currentParentPreset.state.widgets[0].data.tabs = this.dataInners;
			if(!this.isReadOnly){
				this.currentParentPreset.state.widgets[0].data.homeIndex = index;
				PresetService.setPreset(this.msgbus, this.currentParentPreset).onSuccess(resp =>{
					this.scope.$emit('DashboardController:updateParentPreset', this.currentParentPreset);
					this.scope.$apply();
				});
			}
		}.bind(this));
	}

	moveTo(inner, from, to){
		if(to === this.dataInners.length || to < 0){
			this.scope.$emit('DashboardController:notify', {
				type: 'danger',
				title: this.serviceTranslate('$S_str_TabMove'),
				msg: this.serviceTranslate('$S_str_CannotMove'),
				autohide: true
			});
	
			return;
		}// 더이상 이동할 수 없음.
		var tmpInner = null;
		tmpInner = this.dataInners[from];
		this.dataInners[from] = this.dataInners[to];
		this.dataInners[to] = tmpInner;

		this.currentParentPreset.state.widgets[0].data.tabs = this.dataInners;
		if(!this.isReadOnly){
			if(from === this.homeIndex){
				this.currentParentPreset.state.widgets[0].data.homeIndex = to;	
			} else if( to === this.homeIndex){
				this.currentParentPreset.state.widgets[0].data.homeIndex = from;
			}
			PresetService.setPreset(this.msgbus, this.currentParentPreset).onSuccess(resp =>{
				this.scope.$apply();
			});
		}
	}

	destroy() {
		this.presets[this.currentTab.contents].suspend();
	}
}

export default DashboardController;


// WEBPACK FOOTER //
// ./resources/WEB-INF/dashboard/DashboardController.js